import(/* webpackMode: "eager", webpackExports: ["MLMCalculatorPageContent"] */ "/app/components/frontend/mlm-calculator/mlm-calculator-page-content.tsx");
